/**
 * Device and browser detection utilities
 */

/**
 * Check if the current device is iOS
 * @returns {boolean} True if iOS device
 */
export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
}

/**
 * Check if the current device is Android
 * @returns {boolean} True if Android device
 */
export function isAndroid() {
  return /Android/.test(navigator.userAgent)
}

/**
 * Check if the current device is mobile
 * @returns {boolean} True if mobile device
 */
export function isMobile() {
  return isIOS() || isAndroid() || /Mobile/.test(navigator.userAgent)
}

/**
 * Check if the current device is tablet
 * @returns {boolean} True if tablet device
 */
export function isTablet() {
  return /iPad|Android/.test(navigator.userAgent) && window.innerWidth >= 768
}

/**
 * Check if Web Speech API is supported
 * @returns {boolean} True if supported
 */
export function isSpeechRecognitionSupported() {
  return 'webkitSpeechRecognition' in window || 'SpeechRecognition' in window
}

/**
 * Check if Twilio Video is supported
 * @returns {boolean} True if supported
 */
export function isTwilioVideoSupported() {
  return !!(
    navigator.mediaDevices &&
    navigator.mediaDevices.getUserMedia
  )
}

/**
 * Get browser name
 * @returns {string} Browser name
 */
export function getBrowserName() {
  const userAgent = navigator.userAgent

  if (userAgent.includes('Firefox')) return 'Firefox'
  if (userAgent.includes('Chrome') && !userAgent.includes('Edge')) return 'Chrome'
  if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) return 'Safari'
  if (userAgent.includes('Edge')) return 'Edge'
  if (userAgent.includes('Opera')) return 'Opera'

  return 'Unknown'
}

/**
 * Get screen size category
 * @returns {string} Size category (mobile, tablet, desktop)
 */
export function getScreenSize() {
  const width = window.innerWidth

  if (width < 768) return 'mobile'
  if (width < 1024) return 'tablet'
  return 'desktop'
}

/**
 * Check if device supports notifications
 * @returns {boolean} True if supported
 */
export function isNotificationSupported() {
  return 'Notification' in window
}
